import { render, staticRenderFns } from "./CopyFormButton.vue?vue&type=template&id=efda74d6&"
import script from "./CopyFormButton.vue?vue&type=script&lang=js&"
export * from "./CopyFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports